module.exports = __webpack_public_path__ + "static/media/J2.8e921970.jpg";